module.exports = __webpack_public_path__ + "static/media/PaketC.2840cdc4.jpeg";